import React from "react";
import { Button } from "react-bootstrap";
import { handleCancelNFTAuction } from "../../../../../functions/flow-interactions/transactions";

const ColDetailRemoveListingAuction = ({ saleDetails }) => {
  return (
    <Button
      onClick={() =>
        handleCancelNFTAuction(saleDetails.listingId)
      }
      variant="find-collection-outline-red"
    >
      Remove
    </Button>
  );
};

export default ColDetailRemoveListingAuction;
